<template>
  <nav class="sidebar">
    <div class="sidebar-header">
      <div class="row w-100  d-flex justify-content-center align-items-center mb-1 mt-1">
        <div class="col-md-12 text-center">
          <img src="@/assets/img/logo-black.png" alt="store" style="width: 120px;">
          <!-- <div class=" text-center"> {{ currentClub?.name || null }}</div> -->
        </div>
      </div>
      <div class="sidebar-toggler not-active">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="sidebar-body">
      <ul class="nav mb-5" style="padding-bottom: 45px !important;">


        <li class="nav-item mb-2">
          <router-link :to="{ name: 'users', params: { userUUID: userUUID } }" class="nav-link">
            <font-awesome-icon icon="users" size="lg" class="link-icon" />
            <span class="link-title">
              {{ i18n.t('layout.sidbar.admin.assistance') }}  
            </span>
          </router-link>
        </li>
        <li class="nav-item mb-2">
          <router-link :to="{ name: 'affected-user' }" class="nav-link">
            <font-awesome-icon icon="key" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.admin.acces_assistance') }}   </span>
          </router-link>
        </li>
        <li class="nav-item mb-2">
          <router-link :to="{ name: 'permissions-club-packs-id' }" class="nav-link">
            <font-awesome-icon icon="key" size="lg" class="link-icon" />
            <span class="link-title"> {{ i18n.t('layout.sidbar.admin.acces_assistance') }} </span>
          </router-link>
        </li>




      </ul>
      <div class="call-us">
        <div>
          <div>
            <a href="tel:+212633402241">{{ i18n.t('gymya.phone') }}</a>
          </div>
          <div>
            <a href="mailto:contact@gymya.ma">{{ i18n.t('gymya.email') }}</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script lang="ts">
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import { defineComponent, ref, watch, computed } from 'vue';
import { useRoute } from "vue-router";
import { useGlobal } from "@/composables/global/useGlobal";
import { usePermission } from "@/composables/auth/usePermission";
import { userUUID, clubUUID, currentClub } from '@/shared/state';
import { userPermissions } from '@/shared/state';
export default defineComponent({
  name: 'SomeComponent',
  setup() {



    const userPermissionsList = computed(() => userPermissions.data);
    const data = ref<any>(null);
    const error = ref<string | null>(null);
    const { hasPermission } = usePermission();







    return {
      data,
      error,
      // states 
      userPermissionsList,
      hasPermission,
      clubUUID,
      userUUID,
      currentClub,
      i18n
    };
  },
});
</script>

<style></style>